var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3747 14.3185C11.7444 11.9196 15.3242 10.3381 17.1141 9.57385C22.2306 7.39191 23.2925 7.01295 23.986 7.00011C24.1385 6.9976 24.4781 7.03627 24.6997 7.21999C24.8838 7.37494 24.9356 7.58448 24.9615 7.73161C24.9845 7.87859 25.0162 8.21357 24.9903 8.47506C24.714 11.4618 23.5141 18.7098 22.904 22.0552C22.6479 23.4707 22.1385 23.9452 21.6465 23.9916C20.576 24.0925 19.7645 23.2667 18.7285 22.5705C17.1084 21.4806 16.1933 20.8023 14.6192 19.739C12.8005 18.51 13.9804 17.8344 15.0163 16.7306C15.2868 16.4417 20.0004 12.0456 20.0896 11.6469C20.1012 11.597 20.1127 11.4111 20.0033 11.3131C19.8968 11.2148 19.7386 11.2485 19.6235 11.275C19.4594 11.3128 16.8724 13.0683 11.8538 16.5411C11.12 17.0588 10.4552 17.3112 9.85667 17.2979C9.20056 17.2834 7.93439 16.9166 6.99339 16.6031C5.84233 16.2186 4.92435 16.0152 5.00493 15.3621C5.04522 15.0221 5.50276 14.6741 6.3747 14.3185Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8d5c5f11e006753d8e6a11bb1058c4fd.svg";
export { ForwardRef as ReactComponent };